<div [icon]="'PDF'"></div>
<div class="description">
  <div class="name">{{ doc.name }}</div>
  <div class="size">{{ doc.size | fileSize }}</div>
</div>
